import { render, staticRenderFns } from "./ZyroTabs.vue?vue&type=template&id=9d24837c&scoped=true&"
import script from "./ZyroTabs.vue?vue&type=script&lang=js&"
export * from "./ZyroTabs.vue?vue&type=script&lang=js&"
import style0 from "./ZyroTabs.vue?vue&type=style&index=0&id=9d24837c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d24837c",
  null
  
)

export default component.exports